// @ts-nocheck
import Messenger from './messenger'
import { MessageBusListenTypeEum, MessageBusSendTypeEum } from './constants'

let context: any = null

const list: {
  [key: string]: any
} = {}

let buffer: any[] = []

// {
//   name?: string
//   props?: any
//   index?: number
//   activeIndex?: number
// }

type ListenerCb = (params: any) => void

function handleEvent(eventName: string, data: any) {
  if (list[eventName]) {
    list[eventName](data)
  } else {
    console.warn(`${eventName}未注册`)
  }
  // console.error(eventName, data, list[eventName], 'exec listen handler')
}

const messageBus = {
  init: () =>
    new Promise((res, rej) => {
      context = new Messenger('iframe', 'editor')
      context.addTarget(window.parent, 'parent')
      context.listen((msg: MessageBusListenTypeEum) => {
        const { eventName, data } = JSON.parse(msg)
        console.info(JSON.parse(msg))
        handleEvent(eventName, data)
      })
      setTimeout(() => {
        messageBus.send(MessageBusSendTypeEum.$SYSTEM_OK)
        if (buffer.length > 0) {
          buffer.forEach(({ eventName, data }) => {
            context.send(
              JSON.stringify({
                eventName,
                data,
              })
            )
          })
          buffer = []
        }
      }, 300)
    }),

  send(eventName: MessageBusSendTypeEum, data = {}) {
    if (!context) {
      buffer.push({
        eventName,
        data,
      })
      return
    }

    context.send(
      JSON.stringify({
        eventName,
        data,
      })
    )
  },

  listen(eventName: MessageBusListenTypeEum, cb: ListenerCb) {
    if (list[eventName]) {
      console.warn(`重复注册${eventName}`)
      // throw new Error(`重复注册${eventName}`)
    } else {
      list[eventName] = cb
    }
  },
}

export { MessageBusListenTypeEum, MessageBusSendTypeEum }

export default messageBus
